import { render, staticRenderFns } from "./ProductActualStock.vue?vue&type=template&id=5447b72f"
import script from "./ProductActualStock.vue?vue&type=script&lang=ts"
export * from "./ProductActualStock.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports